/* LHC SHOP-57: Filter-Drawer — Marken-/Listen-Suche + Dual-Range-Preisslider.
   Delegierte Events, damit die Handler Morphing-Rerenders von facets.js überleben. */
(function () {
  'use strict';
  if (window.__lhcMobileFilter) return;
  window.__lhcMobileFilter = true;

  /* Listen-Suche: filtert die Checkbox-Zeilen der Sektion nach Label-Text */
  document.addEventListener('input', function (event) {
    var field = event.target;
    if (!(field instanceof HTMLInputElement) || !field.hasAttribute('data-lhc-facet-search')) return;
    var panel = field.closest('facet-inputs-component');
    if (!panel) return;
    var query = field.value.trim().toLowerCase();
    panel.querySelectorAll('.facets__inputs-list-item').forEach(function (item) {
      var label = item.textContent.trim().toLowerCase();
      item.hidden = query !== '' && label.indexOf(query) === -1;
    });
  });

  /* Dual-Range: zwei überlagerte range-Inputs, spiegeln in die Min/Max-Felder */
  function syncRange(range) {
    var wrapper = range.closest('[data-lhc-dual-range]');
    if (!wrapper) return;
    var minRange = wrapper.querySelector('[data-lhc-range="min"]');
    var maxRange = wrapper.querySelector('[data-lhc-range="max"]');
    if (!minRange || !maxRange) return;

    var lo = parseInt(minRange.value, 10) || 0;
    var hi = parseInt(maxRange.value, 10) || 0;
    if (lo > hi) {
      if (range === minRange) {
        hi = lo;
        maxRange.value = hi;
      } else {
        lo = hi;
        minRange.value = lo;
      }
    }
    var max = parseInt(maxRange.max, 10) || 1;
    wrapper.style.setProperty('--lo', (lo / max) * 100 + '%');
    wrapper.style.setProperty('--hi', (hi / max) * 100 + '%');

    var component = wrapper.closest('price-facet-component');
    if (!component) return { lo: lo, hi: hi, max: max };
    var minInput = component.querySelector('[ref="minInput"]');
    var maxInput = component.querySelector('[ref="maxInput"]');
    if (minInput) minInput.value = lo > 0 ? lo : '';
    if (maxInput) maxInput.value = hi < max ? hi : '';
    return { minInput: minInput, maxInput: maxInput };
  }

  document.addEventListener('input', function (event) {
    var range = event.target;
    if (!(range instanceof HTMLInputElement) || !range.hasAttribute('data-lhc-range')) return;
    syncRange(range);
  });

  /* Loslassen: Change am Textfeld auslösen, damit price-facet-component die Ergebnisse lädt */
  document.addEventListener('change', function (event) {
    var range = event.target;
    if (!(range instanceof HTMLInputElement) || !range.hasAttribute('data-lhc-range')) return;
    var refs = syncRange(range) || {};
    var input = range.dataset.lhcRange === 'min' ? refs.minInput : refs.maxInput;
    if (input) input.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();
